import { Routes, Route } from 'react-router-dom'
import { Package, AlertTriangle, AlertCircle } from 'lucide-react'
import { useI18n } from '../i18n'
import SupplierInventory from './tpsm/Inventory'
import TPSMRiskScores from './tpsm/RiskScores'
import TPSMIncidents from './tpsm/Incidents'
import SupplierProfile from './tpsm/SupplierProfile'
import { PageLayout } from '../layouts/PageLayout'
import { TpsmNavTabs } from '../components/tpsm/TpsmNavTabs'

const TPSM: React.FC = () => {
  const { t } = useI18n()

  const navItems = [
    {
      key: 'inventory',
      to: '/tpsm/inventory',
      label: t('tpsm.nav.inventory', 'Supplier Inventory'),
      icon: <Package aria-hidden />,
    },
    {
      key: 'riskScores',
      to: '/tpsm/risk-scores',
      label: t('tpsm.nav.riskScores', 'Supplier Risk Scores'),
      icon: <AlertTriangle aria-hidden />,
    },
    {
      key: 'incidents',
      to: '/tpsm/incidents',
      label: t('tpsm.nav.incidents', 'Incidents with Suppliers'),
      icon: <AlertCircle aria-hidden />,
    },
  ]

  return (
    <PageLayout
      pageScope="tpsm-page"
      title={t('tpsm.title', 'Third-Party Security Management')}
      description={t('tpsm.subtitle', 'Manage supplier security, assessments, and risks')}
    >
      <TpsmNavTabs items={navItems} />

      <div className="min-w-0">
        <Routes>
          <Route index element={<SupplierInventory />} />
          <Route path="inventory" element={<SupplierInventory />} />
          <Route path="supplier/:supplierId" element={<SupplierProfile />} />
          <Route path="risk-scores" element={<TPSMRiskScores />} />
          <Route path="incidents" element={<TPSMIncidents />} />
        </Routes>
      </div>
    </PageLayout>
  )
}

export default TPSM
